// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileTabletCallbackForm_container__g6eaQ {
    display: flex;
    flex-direction: column;
}

.MobileTabletCallbackForm_input__suf-D {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-light-01);
    padding: 16px 20px;
    outline: none;
    font-size: var(--font-size-8);
    color: var(--primary-light);
    font-family: var(--font-medium), sans-serif;
    transition: border-color 0.3s ease-out;
    flex-grow: 1;
}

.MobileTabletCallbackForm_input__suf-D:focus {
    border-color: var(--primary-accent);
}

.MobileTabletCallbackForm_inputWrapper__O4SLM {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-dark);
    display: flex;
    align-items: center;
}

.MobileTabletCallbackForm_selectWrapper__8czXj {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-dark);
    padding: 16px 20px;
    display: flex;
    align-items: center;
}

.MobileTabletCallbackForm_focused__Jbf9a {
    border-color: var(--primary-accent);
    transition: border-color 0.3s ease-out;
}

.MobileTabletCallbackForm_select__5U\\+\\+D {
    background-color: transparent;
    outline: none;
    font-size: var(--font-size-8);
    border: none;
    width: 100%;
    color: var(--primary-light);
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletCallbackForm_rtl__LqUpN {
    direction: rtl;
}

.MobileTabletCallbackForm_formButton__b9E6V {
    color: var(--primary-light);
    font-family: var(--font-semi-bold), sans-serif;
    font-size: var(--font-size-5);
    background-color: var(--primary-accent);
    border-radius: 50px;
    padding: 16px 20px;
    cursor: pointer;
    transition: all 0.3s ease-out;
}

.MobileTabletCallbackForm_formButton__b9E6V:hover,
.MobileTabletCallbackForm_formButton__b9E6V:active {
    background-color: var(--primary-accent-08);
}

.MobileTabletCallbackForm_tabletRow__0TbyO {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.MobileTabletCallbackForm_tabletRow__0TbyO > div {
    width: 49%;
    display: flex;
    flex-direction: column;
}

.MobileTabletCallbackForm_error__e--rA {
    font-size: var(--font-size-5);
    color: #fb3958;
    font-family: var(--font-medium), sans-serif;
    opacity: 1;
    max-height: 50px; /* Adjust based on your needs */
    transition: opacity 0.3s ease, max-height 0.3s ease-out;
    padding: 0 12px;
    margin-top: 12px;
}

.MobileTabletCallbackForm_error__e--rA.MobileTabletCallbackForm_visible__cWUQQ {
    opacity: 1;
    max-height: 50px; /* Adjust based on your needs */
}

.MobileTabletCallbackForm_separator__amnZw {
    width: 1px;
    height: 100%;
    background-color: var(--primary-dark);
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak {
    border: 1.5px solid var(--primary-dark-01);
    margin-bottom: 20px;
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak .PhoneInput {
    padding: 16px 20px;
    border: 1.5px solid var(--primary-light-01);
    border-radius: 16px;
    transition: border-color 0.3s ease-out;
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak .PhoneInput--focus {
    border: solid 1.5px var(--primary-accent);
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak .PhoneInputInput {
    background-color: transparent;
    border: none;
    color: var(--primary-light);
    outline: none;
    width: 100%;
    height: 100%;
    padding: 0px 8px;
    font-size: var(--font-size-8);
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak .PhoneInputCountry {
    height: 100%;
    gap: 8px;
}

.MobileTabletCallbackForm_tabletPhoneInput__Q1iak .PhoneInputCountrySelect {
    outline: none;
}

.MobileTabletCallbackForm_successMessage__X3nJu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    row-gap: 10px;
    text-align: center;
    padding: 10px 0px;
}

.MobileTabletCallbackForm_successMessage__X3nJu button {
    position: absolute;
    top: -5%;
    right: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.MobileTabletCallbackForm_successTitle__oTnfa {
    font-size: var(--font-size-4);
    font-family: var(--font-semi-bold), sans-serif;
    color: var(--primary-accent);
}

.MobileTabletCallbackForm_successText__x2qzu {
    font-size: var(--font-size-8);
    font-family: var(--font-semi-bold), sans-serif;
    color: var(--primary-light);
}

.MobileTabletCallbackForm_successSubText__QFTMU {
    font-size: var(--font-size-4);
    font-family: var(--font-medium), sans-serif;
    color: var(--primary-light-06);
}

@media (max-width: 767px) {
    .MobileTabletCallbackForm_container__g6eaQ {
        gap: 4px;
    }
    .MobileTabletCallbackForm_input__suf-D {
        border-radius: 16px;
        padding: 16px 12px;
        font-size: 16px;
    }

    .MobileTabletCallbackForm_select__5U\\+\\+D {
        padding: 4px;
        font-size: 16px;
    }

    .MobileTabletCallbackForm_formButton__b9E6V {
        padding: 14px;
        font-size: var(--font-size-5);
    }

    .MobileTabletCallbackForm_selectWrapper__8czXj {
        padding: 10px 10px;
        margin-top: 6px;
        margin-bottom: 16px;
    }

    .MobileTabletCallbackForm_temporary__QxHQk {
        padding: 10px 12px;
    }

    .MobileTabletCallbackForm_formButton__b9E6V {
        padding: 16px 20px;
    }

    .MobileTabletCallbackForm_tabletRow__0TbyO {
        flex-direction: column;
        align-items: unset;
        justify-content: unset;
    }

    .MobileTabletCallbackForm_tabletRow__0TbyO > input {
        width: unset;
    }
    .MobileTabletCallbackForm_tabletRow__0TbyO > div {
        width: unset;
    }

    .MobileTabletCallbackForm_phoneInputWrapper__VaTlT {
        min-height: 50px;
    }

    .PhoneInputInput {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Form/MobileTabletCallbackForm/MobileTabletCallbackForm.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,2CAA2C;IAC3C,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,6BAA6B;IAC7B,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,2CAA2C;IAC3C,UAAU;IACV,gBAAgB,EAAE,+BAA+B;IACjD,uDAAuD;IACvD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n}\n\n.input {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-light-01);\n    padding: 16px 20px;\n    outline: none;\n    font-size: var(--font-size-8);\n    color: var(--primary-light);\n    font-family: var(--font-medium), sans-serif;\n    transition: border-color 0.3s ease-out;\n    flex-grow: 1;\n}\n\n.input:focus {\n    border-color: var(--primary-accent);\n}\n\n.inputWrapper {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-dark);\n    display: flex;\n    align-items: center;\n}\n\n.selectWrapper {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-dark);\n    padding: 16px 20px;\n    display: flex;\n    align-items: center;\n}\n\n.focused {\n    border-color: var(--primary-accent);\n    transition: border-color 0.3s ease-out;\n}\n\n.select {\n    background-color: transparent;\n    outline: none;\n    font-size: var(--font-size-8);\n    border: none;\n    width: 100%;\n    color: var(--primary-light);\n    font-family: var(--font-medium), sans-serif;\n}\n\n.rtl {\n    direction: rtl;\n}\n\n.formButton {\n    color: var(--primary-light);\n    font-family: var(--font-semi-bold), sans-serif;\n    font-size: var(--font-size-5);\n    background-color: var(--primary-accent);\n    border-radius: 50px;\n    padding: 16px 20px;\n    cursor: pointer;\n    transition: all 0.3s ease-out;\n}\n\n.formButton:hover,\n.formButton:active {\n    background-color: var(--primary-accent-08);\n}\n\n.tabletRow {\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.tabletRow > div {\n    width: 49%;\n    display: flex;\n    flex-direction: column;\n}\n\n.error {\n    font-size: var(--font-size-5);\n    color: #fb3958;\n    font-family: var(--font-medium), sans-serif;\n    opacity: 1;\n    max-height: 50px; /* Adjust based on your needs */\n    transition: opacity 0.3s ease, max-height 0.3s ease-out;\n    padding: 0 12px;\n    margin-top: 12px;\n}\n\n.error.visible {\n    opacity: 1;\n    max-height: 50px; /* Adjust based on your needs */\n}\n\n.separator {\n    width: 1px;\n    height: 100%;\n    background-color: var(--primary-dark);\n}\n\n.tabletPhoneInput {\n    border: 1.5px solid var(--primary-dark-01);\n    margin-bottom: 20px;\n}\n\n.tabletPhoneInput :global(.PhoneInput) {\n    padding: 16px 20px;\n    border: 1.5px solid var(--primary-light-01);\n    border-radius: 16px;\n    transition: border-color 0.3s ease-out;\n}\n\n.tabletPhoneInput :global(.PhoneInput--focus) {\n    border: solid 1.5px var(--primary-accent);\n}\n\n.tabletPhoneInput :global(.PhoneInputInput) {\n    background-color: transparent;\n    border: none;\n    color: var(--primary-light);\n    outline: none;\n    width: 100%;\n    height: 100%;\n    padding: 0px 8px;\n    font-size: var(--font-size-8);\n    font-family: var(--font-medium), sans-serif;\n}\n\n.tabletPhoneInput :global(.PhoneInputCountry) {\n    height: 100%;\n    gap: 8px;\n}\n\n.tabletPhoneInput :global(.PhoneInputCountrySelect) {\n    outline: none;\n}\n\n.successMessage {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    row-gap: 10px;\n    text-align: center;\n    padding: 10px 0px;\n}\n\n.successMessage button {\n    position: absolute;\n    top: -5%;\n    right: 0;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.successTitle {\n    font-size: var(--font-size-4);\n    font-family: var(--font-semi-bold), sans-serif;\n    color: var(--primary-accent);\n}\n\n.successText {\n    font-size: var(--font-size-8);\n    font-family: var(--font-semi-bold), sans-serif;\n    color: var(--primary-light);\n}\n\n.successSubText {\n    font-size: var(--font-size-4);\n    font-family: var(--font-medium), sans-serif;\n    color: var(--primary-light-06);\n}\n\n@media (max-width: 767px) {\n    .container {\n        gap: 4px;\n    }\n    .input {\n        border-radius: 16px;\n        padding: 16px 12px;\n        font-size: 16px;\n    }\n\n    .select {\n        padding: 4px;\n        font-size: 16px;\n    }\n\n    .formButton {\n        padding: 14px;\n        font-size: var(--font-size-5);\n    }\n\n    .selectWrapper {\n        padding: 10px 10px;\n        margin-top: 6px;\n        margin-bottom: 16px;\n    }\n\n    .temporary {\n        padding: 10px 12px;\n    }\n\n    .formButton {\n        padding: 16px 20px;\n    }\n\n    .tabletRow {\n        flex-direction: column;\n        align-items: unset;\n        justify-content: unset;\n    }\n\n    .tabletRow > input {\n        width: unset;\n    }\n    .tabletRow > div {\n        width: unset;\n    }\n\n    .phoneInputWrapper {\n        min-height: 50px;\n    }\n\n    :global(.PhoneInputInput) {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletCallbackForm_container__g6eaQ`,
	"input": `MobileTabletCallbackForm_input__suf-D`,
	"inputWrapper": `MobileTabletCallbackForm_inputWrapper__O4SLM`,
	"selectWrapper": `MobileTabletCallbackForm_selectWrapper__8czXj`,
	"focused": `MobileTabletCallbackForm_focused__Jbf9a`,
	"select": `MobileTabletCallbackForm_select__5U++D`,
	"rtl": `MobileTabletCallbackForm_rtl__LqUpN`,
	"formButton": `MobileTabletCallbackForm_formButton__b9E6V`,
	"tabletRow": `MobileTabletCallbackForm_tabletRow__0TbyO`,
	"error": `MobileTabletCallbackForm_error__e--rA`,
	"visible": `MobileTabletCallbackForm_visible__cWUQQ`,
	"separator": `MobileTabletCallbackForm_separator__amnZw`,
	"tabletPhoneInput": `MobileTabletCallbackForm_tabletPhoneInput__Q1iak`,
	"successMessage": `MobileTabletCallbackForm_successMessage__X3nJu`,
	"successTitle": `MobileTabletCallbackForm_successTitle__oTnfa`,
	"successText": `MobileTabletCallbackForm_successText__x2qzu`,
	"successSubText": `MobileTabletCallbackForm_successSubText__QFTMU`,
	"temporary": `MobileTabletCallbackForm_temporary__QxHQk`,
	"phoneInputWrapper": `MobileTabletCallbackForm_phoneInputWrapper__VaTlT`
};
export default ___CSS_LOADER_EXPORT___;
